import { inject, Injectable } from '@angular/core';
import { CustomWindow, ExternalConfig, PkceService, Token } from '@bcef/ia-shared';
import { WA_WINDOW } from '@ng-web-apis/common';
import { Observable } from 'rxjs';
import { UrlParams } from 'src/app/features/global/interfaces';

@Injectable({ providedIn: 'root' })
export class ReconciliationService {
  private readonly customWindow: CustomWindow = inject<CustomWindow>(WA_WINDOW);

  private readonly pkce = inject(PkceService);

  public getToken(urlParams: UrlParams): Observable<Token> {
    const requestObj: ExternalConfig = {};
    requestObj.redirect_uri = `${window.location.origin}${this.customWindow.APPS_BASE_HREF}/reconciliation`;
    if (urlParams.code) {
      requestObj.code = urlParams.code;
    }
    return this.pkce.getToken(requestObj);
  }
}
